export default __webpack_public_path__ + "static/epilogue-latin-variable-wghtOnly-normal-5fe9feb42a7a3096c7f27e858e546077.woff2";